import { SET_LEAGUES_RESULT, SET_FILTER_LEAGUES, SET_FILTER_RESULTS } from "./actionTypes";
import { RootState } from "../store";

const INITIAL_STATE = {
  league: {
    id: 0,
    name: 'Tất cả giải đấu'
  },
};

const LeagueReducer = (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_LEAGUES_RESULT:
      return {
        ...state,
        league: action.payload,
      };
    case SET_FILTER_LEAGUES:
      return { ...state, filterLeagues: action.payload };
    case SET_FILTER_RESULTS:
      return { ...state, filterResults: action.payload };  
    default:
      return state;
  }
};

export default LeagueReducer;
